(function () {
  var ROOT_SELECTOR = "[data-alter-down-time]";
  var DEFAULT_DURATION = 5 * 60 * 1000;
  // 50ms 足够表现百分秒跳动，避免每帧 rAF + 强制回流拖高 INP
  var TICK_MS = 50;
  var refreshFrame = null;

  window.AlterDownTime = window.AlterDownTime || {};
  // 挂到命名空间，避免重复加载/缓存错位时闭包里读不到局部变量
  window.AlterDownTime.TICK_MS = TICK_MS;

  if (window.AlterDownTime.loaded) {
    window.AlterDownTime.init(document);
    return;
  }

  var instances = new WeakMap();
  var observed = new WeakSet();
  var visibilityObserver = null;
  // INP：用户触摸/点击期间暂停 DOM 更新，交互绘制完成后再恢复
  var pausedForInteraction = false;
  var interactionListenersBound = false;

  function pad2(value) {
    return String(value).padStart(2, "0");
  }

  function isVisible(root) {
    return Boolean(root && root.isConnected && root.getClientRects().length);
  }

  function formatTime(remaining) {
    var safeRemaining = Math.max(0, remaining);
    var minutes = Math.floor(safeRemaining / 60000);
    var seconds = Math.floor((safeRemaining % 60000) / 1000);
    var centiseconds = Math.floor((safeRemaining % 1000) / 10);

    return {
      minutes: pad2(minutes),
      seconds: pad2(seconds),
      milliseconds: pad2(centiseconds),
    };
  }

  function setPart(root, part, value, animate) {
    var unit = root.querySelector('[data-countdown-part="' + part + '"]');
    var valueNode = unit && unit.querySelector(".alter-down-time__value");

    if (!unit || !valueNode || valueNode.textContent === value) {
      return;
    }

    if (valueNode.firstChild) {
      valueNode.firstChild.nodeValue = value;
    } else {
      valueNode.textContent = value;
    }

    // 仅分/秒做翻页动画；毫秒位高频变化不做动画，且不再读 offsetWidth 强制回流
    if (!animate) return;

    unit.classList.remove("is-flipping");
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(function () {
        unit.classList.add("is-flipping");
      });
    } else {
      unit.classList.add("is-flipping");
    }
  }

  function render(root, remaining) {
    var time = formatTime(remaining);
    var timer = root.querySelector(".alter-down-time__timer");

    setPart(root, "minutes", time.minutes, true);
    setPart(root, "seconds", time.seconds, true);
    setPart(root, "milliseconds", time.milliseconds, false);

    if (timer) {
      timer.setAttribute(
        "aria-label",
        "Offer ends in " + time.minutes + " minutes " + time.seconds + " seconds"
      );
    }
  }

  function stop(root) {
    var state = instances.get(root);

    if (!state) {
      return;
    }

    if (state.intervalId) {
      clearInterval(state.intervalId);
    }

    instances.delete(root);
  }

  function start(root) {
    if (!root || instances.has(root) || !isVisible(root)) {
      return;
    }

    var duration = Number(root.getAttribute("data-duration")) || DEFAULT_DURATION;
    var tickMs = window.AlterDownTime.TICK_MS || 50;
    var state = {
      intervalId: null,
      startedAt: performance.now(),
    };

    instances.set(root, state);
    render(root, duration);

    state.intervalId = setInterval(function () {
      if (pausedForInteraction) return;
      if (!isVisible(root)) {
        stop(root);
        return;
      }

      var elapsed = (performance.now() - state.startedAt) % duration;
      var remaining = duration - elapsed;
      render(root, remaining);
    }, tickMs);
  }

  function pauseForInteraction() {
    pausedForInteraction = true;
  }

  function unpauseAfterPaint() {
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          pausedForInteraction = false;
        });
      });
    } else {
      setTimeout(function () {
        pausedForInteraction = false;
      }, 32);
    }
  }

  function bindInteractionPause() {
    if (interactionListenersBound || typeof document === "undefined") return;
    interactionListenersBound = true;
    var opts = { capture: true, passive: true };
    document.addEventListener("pointerdown", pauseForInteraction, opts);
    document.addEventListener("pointerup", unpauseAfterPaint, opts);
    document.addEventListener("pointercancel", unpauseAfterPaint, opts);
  }

  function ensureVisibilityObserver() {
    if (visibilityObserver || typeof IntersectionObserver !== "function") {
      return visibilityObserver;
    }

    visibilityObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting && entry.intersectionRatio > 0) {
            start(entry.target);
          } else {
            stop(entry.target);
          }
        }
      },
      { threshold: 0 }
    );

    return visibilityObserver;
  }

  function observeRoot(root) {
    if (!root) return;

    if (!observed.has(root)) {
      observed.add(root);
      var io = ensureVisibilityObserver();
      if (io) {
        io.observe(root);
      }
    }

    // MutationObserver 再次 init 时也要按可见性启停，不能因已 observe 就直接 return
    if (isVisible(root)) {
      start(root);
    } else {
      stop(root);
    }
  }

  function init(scope) {
    var container = scope || document;
    var roots =
      container.matches && container.matches(ROOT_SELECTOR)
        ? [container]
        : container.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, observeRoot);
  }

  window.AlterDownTime.init = init;
  window.AlterDownTime.start = start;
  window.AlterDownTime.stop = stop;
  window.AlterDownTime.loaded = true;

  // 仅监听弹窗容器的显示状态变化，避免整页 subtree MutationObserver 抢主线程
  var popupRoots = [
    ".sunber-wheel-poupop-con",
    ".three-hundred-voucher-package-con",
    ".all-voucher-package-con",
  ];

  function observePopupDisplay() {
    if (typeof MutationObserver !== "function") return;

    popupRoots.forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;

      new MutationObserver(function () {
        init(el);
      }).observe(el, {
        attributes: true,
        attributeFilter: ["style", "class", "hidden"],
        childList: false,
        subtree: false,
      });
    })

    function showDownTimeContainer(scope) {
      console.log('测2调用 showDownTimeContainer');
      
      var container = scope || document;
      var target = container.matches && container.matches('.sunber-wheel-poupop-down-time')
        ? container
        : container.querySelector('.sunber-wheel-poupop-down-time');

      if (target && target.style.display === 'none') {
        target.style.display = 'block';
      }
    }

    showDownTimeContainer(document);

    window.AlterDownTime = window.AlterDownTime || {};
    window.AlterDownTime.init = init;
    window.AlterDownTime.start = start;
    window.AlterDownTime.stop = stop;
    window.AlterDownTime.loaded = true;

    function scheduleInit() {
      if (refreshFrame) {
        return;
      }

      refreshFrame = requestAnimationFrame(function () {
        refreshFrame = null;
        init(document);
      });
    }

    new MutationObserver(scheduleInit).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
      childList: true,
      subtree: true
    });
  }

  bindInteractionPause();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
      observePopupDisplay();
    });
  } else {
    init(document);
    observePopupDisplay();
  }
})();
